import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';


class Earring2021 extends React.Component {

	static propTypes = {
		location: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.any,
		router: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);

		const firstEntry = [{display: 'Location*', 'value': ''}];
		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesignerLocation: null,

			bgWidth: 0,
			bgHeight: 0,
		};

		// Bind event listeners
    this.adjustBackground = ::this.adjustBackground;
	}

  componentWillMount() {
    window.addEventListener('resize', this.adjustBackground, false);
  }

  componentDidMount() {
    this.adjustBackground();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustBackground, false);
  }

  adjustBackground() {

    const clientWidth = this.topBox.clientWidth;
    const clientHeight = this.topBox.clientHeight;

    this.setState({
    	bgWidth: clientWidth,
			bgHeight: clientHeight,
    });
  }

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	giftsNav(pg = '') {
		window.location.href = 'https://gifts.diamondsdirect.com/' + pg;
	}

	openIntercom() {
    acquireIO.max();
  }

	getLocationDesigners() {
		return [];
	}

	changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	changeDesigner(evt) {
		this.setState({ inputDesigner: evt.target.value });
	}

	changeDesignerLocation(evt) {
		this.setState({ designerLocation: evt.target.value });
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

  getShowDates(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.dates;
  		}
  	}
  	return '';
  }

  getShowLink(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.page;
  		}
  	}
  	return '';
  }

  designerNav(page) {
  	if(!page) { return; }
  	this.internalNav(page);
  }

	render() {

		return <div className='Earring2021'>

			<img src="https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=7333a400-055a-4ea4-a1b7-835149f34435" width="1" height="1" />

			<div className='headerSection'>
				<div className='headerSectionWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/ee_banner.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/ee_banner_m.jpg' />
				</div>
			</div>

			<div className='topSection'>
				<div className='topP'>To help you celebrate with the ones you love most this year, we're putting together some <strong>amazing surprises!</strong></div>
				<div className='topP'>Check in with us online or in-store to take advantage of:</div>
				<div className='topTitleImg'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/25percent.svg' />
				</div>
				<div className='topGallery'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/editorial.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/editorial_m.jpg' />
					<div className={'ol ol1'} onClick={() => this.internalNav('jewelry/EFAND18102')}></div>
					<div className={'ol ol2'} onClick={() => this.internalNav('diamond-studs')}></div>
					<div className={'ol ol3'} onClick={() => this.internalNav('jewelry/ECLST05682')}></div>
					<div className={'ol ol4'} onClick={() => this.internalNav('jewelry/EFAND17506')}></div>
				</div>
				<div className='topLegal'>*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers.</div>
			</div>

			<div className='formSection'>
				
				<div className='formBoxWrapper'>
					<div className='formInnerWrapper'>
						<div className='formP'>Walk-in visits are always welcome! But if you’d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!</div>
						<div className='formWrapper'>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorName ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Full Name*'
									value={this.state.inputName}
                	onChange={::this.changeName} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorEmail ? 'textInput error' : 'textInput'}
									type='email' 
									placeholder='Email Address*'
									value={this.state.inputEmail}
                	onChange={::this.changeEmail} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorPhone ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Telephone'
									value={this.state.inputPhone}
                	onChange={::this.changePhone} />
							</div>
							<div className='formInputWrapper'>
								<RhinoSelect
	                selectClass={'summerSelect'}
	                required={true}
	                value={this.state.inputLocation}
	                options={this.state.locations}
	                changeMethod={(evt) => this.changeLocation(evt)}
	                error={this.state.errorLocation !== null} />
							</div>
							<div className='formActionRow'>
								<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='ggSection'>
				<div className='ggTitle'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/earring2021/landing/gg.svg' />
				</div>
				<div className='ggLine'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline.svg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/holiday2021/landing/iline_m.svg' />
				</div>
				<div className='ggP'>Diamonds Direct invites you to enjoy this holiday season with a little extra sparkle! From now until the ball drops we’ll be toasting to the best part of the year.</div>
				<div className='ggP'>Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!</div>
				<div className='ggButton' onClick={() => this.giftsNav()}>Shop Holiday Gifts</div>

				<div className='ggItemRow'>
					<div className={'ggItem'} onClick={() => this.internalNav('jewelry/BLDXL18079')}>
						<div className={'ggItemImg ggItemImg1'}></div>
						<div className={'ggItemLabel'}>Emerald Diamond Halo Ring</div>
					</div>
					<div className={'ggItem'} onClick={() => this.internalNav('jewelry/BLDMD30060')}>
						<div className={'ggItemImg ggItemImg2'}></div>
						<div className={'ggItemLabel'}>Simon G. Butterfly Diamond Ring</div>
					</div>
					<div className={'ggItem'} onClick={() => this.internalNav('jewelry/NFANC29328')}>
						<div className={'ggItemImg ggItemImg3'}></div>
						<div className={'ggItemLabel'}>Baguette Diamond Circle Pendant</div>
					</div>
					<div className={'ggItem'} onClick={() => this.internalNav('jewelry/EFAND14379')}>
						<div className={'ggItemImg ggItemImg4'}></div>
						<div className={'ggItemLabel'}>Diamond Floral Inspired Studs</div>
					</div>
				</div>
			</div>
			
		</div>;
	}
}
export default Earring2021;

function mapStateToProps(state) {
  return {

  };
}

export const Earring2021Container = connect(
  mapStateToProps,
  allActionCreators
)(Earring2021);


// WEBPACK FOOTER //
// ./src/components/views/promopages/earring2021/Earring2021.jsx